function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.9062 34.8438H7.09375C3.27813 34.8438 0.15625 31.7219 0.15625 27.9062V7.09375C0.15625 3.27813 3.27813 0.15625 7.09375 0.15625H27.9062C31.7219 0.15625 34.8438 3.27813 34.8438 7.09375V27.9062C34.8438 31.7219 31.7219 34.8438 27.9062 34.8438Z",
  fill: "url(#paint0_radial_107_183)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.125 29.6406H12.875C8.7125 29.6406 5.35938 26.2875 5.35938 22.125V12.875C5.35938 8.7125 8.7125 5.35938 12.875 5.35938H22.125C26.2875 5.35938 29.6406 8.7125 29.6406 12.875V22.125C29.6406 26.2875 26.2875 29.6406 22.125 29.6406ZM12.875 6.51562C9.34844 6.51562 6.51562 9.34844 6.51562 12.875V22.125C6.51562 25.6516 9.34844 28.4844 12.875 28.4844H22.125C25.6516 28.4844 28.4844 25.6516 28.4844 22.125V12.875C28.4844 9.34844 25.6516 6.51562 22.125 6.51562H12.875Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 23.8594C13.9734 23.8594 11.1406 21.0266 11.1406 17.5C11.1406 13.9734 13.9734 11.1406 17.5 11.1406C21.0266 11.1406 23.8594 13.9734 23.8594 17.5C23.8594 21.0266 21.0266 23.8594 17.5 23.8594ZM17.5 12.2969C14.6094 12.2969 12.2969 14.6094 12.2969 17.5C12.2969 20.3906 14.6094 22.7031 17.5 22.7031C20.3906 22.7031 22.7031 20.3906 22.7031 17.5C22.7031 14.6094 20.3906 12.2969 17.5 12.2969Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M24.4375 12.2969C23.4547 12.2969 22.7031 11.5453 22.7031 10.5625C22.7031 9.57969 23.4547 8.82812 24.4375 8.82812C25.4203 8.82812 26.1719 9.57969 26.1719 10.5625C26.1719 11.5453 25.4203 12.2969 24.4375 12.2969ZM24.4375 9.98438C24.0906 9.98438 23.8594 10.2156 23.8594 10.5625C23.8594 10.9094 24.0906 11.1406 24.4375 11.1406C24.7844 11.1406 25.0156 10.9094 25.0156 10.5625C25.0156 10.2156 24.7844 9.98438 24.4375 9.98438Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_107_183",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(2.75703 35.1321) rotate(-24.2685) scale(54.0599 43.7885)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9ED32"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2555,
  stopColor: "#F59F4F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6535,
  stopColor: "#EE2A7B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6848,
  stopColor: "#E32A81"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7394,
  stopColor: "#C72A91"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8107,
  stopColor: "#982AAB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.896,
  stopColor: "#582ACE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9922,
  stopColor: "#072AFB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#002AFF"
})));

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.530574eca90ed8096b316e0ead47890f.svg";
export { ForwardRef as ReactComponent };